"use client";
import { useState, useEffect } from "react";
import { Link } from "@/navigation.ts";
import { getInquiry } from "@/lib/utils/util";
import CountBadge from "@/components/Badge/count-badge";

const InquiryBtn = ({ lastScrollPosition }: { lastScrollPosition: number }) => {
	const [inquiryCount, setInquiryCount] = useState(0);

	useEffect(() => {
		const handleStorageChange = () => {
			const inquiryData = getInquiry();
			setInquiryCount(inquiryData.length > 99 ? 99 : inquiryData.length);
		};

		handleStorageChange();
		window.addEventListener("storage", handleStorageChange);
		return () => window.removeEventListener("storage", handleStorageChange);
	}, []);

	return (
		<Link
			href="/inquiry"
			className="flex h-8 w-8 items-center justify-center rounded-full text-brand-ink/45 transition-colors duration-200 hover:bg-brand-ink/5 hover:text-brand-ink max-md:!hidden"
		>
			<i className="ri-file-list-line relative text-[18px]">
				<CountBadge count={inquiryCount} />
			</i>
		</Link>
	);
};

export default InquiryBtn;
